import React, {useEffect, useState} from 'react';
import {Button, Form, Input, message, Modal, Select, Space} from 'antd';
import {useBoolean, useInput} from 'react-hanger';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {SubmissionApi, TermApi, TermStatus} from '../../scaffold';
import Text from 'antd/lib/typography/Text';
import DateFormat from '../../utils/DateFormat';
import TermStatusTag from '../Term/TermStatusTag';
import CommonApiErrorHandler from '../../utils/HttpInstance';

export default function SubmissionCreateBtn(props: {refresh: () => any}) {
  const isDialog = useBoolean(false);
  const title = useInput('');
  const [termId, setTermId] = useState<number>();
  const listTerm = useOpenApiFpRequest(TermApi, TermApi.prototype.termListGet);
  const createState = useOpenApiFpRequest(SubmissionApi, SubmissionApi.prototype.submissionCreatePost);

  function create() {
    if (!termId) return;
    if (!title.value) return;
    createState
      .request({
        createSubmissionModel: {
          title: title.value,
          termId,
        },
      })
      .then(() => {
        message.success('已提交申请');
        isDialog.setFalse();
        props.refresh();
      })
      .catch(CommonApiErrorHandler);
  }

  useEffect(() => {
    listTerm.requestSync({});
  }, []);
  return (
    <React.Fragment>
      <Button onClick={isDialog.setTrue} type={'primary'}>
        创建新的申请
      </Button>
      <Modal
        title={'提交新申请'}
        visible={isDialog.value}
        onCancel={isDialog.setFalse}
        confirmLoading={createState.loading}
        onOk={create}
        okButtonProps={{disabled: !title.value || !termId}}>
        <Form>
          <Form.Item label={'论文名称'} required>
            <Input placeholder={'请输入论文名称'} {...title.eventBind} />
          </Form.Item>
          <Form.Item label={'答辩批次'} required>
            <Select placeholder={'请选择批次'} value={termId} onChange={setTermId} allowClear>
              {listTerm.data?.map(term => (
                <Select.Option key={term.id} value={term.id as number} disabled={term.termStatus !== TermStatus.进行中}>
                  <Space size={2}>
                    <TermStatusTag status={term.termStatus as any} />
                    <Text>{term.name}</Text>
                  </Space>
                  <div>
                    <Text type={'secondary'} style={{fontSize: 12}}>
                      {DateFormat.simple(term.beginTime)} 到 {DateFormat.simple(term.endTime)}
                    </Text>
                  </div>
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </React.Fragment>
  );
}
